import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  VStack,
  Text,
  List,
  ListItem,
  useMediaQuery,
} from '@chakra-ui/react';

export default function EmbassyInstructionsModal({ isOpen, onClose }) {
  const [isMobile] = useMediaQuery('(max-width: 768px)');

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>How to Get Your Embassy Appointment URL</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} align="stretch">
            <Text fontWeight="semibold" fontSize="md">
              Follow these steps to get your appointment URL:
            </Text>
            {isMobile ? (
              // Mobile version - shorter instructions
              <List spacing={3}>
                <ListItem>
                  <Text fontWeight="medium" fontSize="sm">1. Sign up on Swiss visa website</Text>
                </ListItem>
                <ListItem>
                  <Text fontWeight="medium" fontSize="sm">2. Select Country & Embassy</Text>
                </ListItem>
                <ListItem>
                  <Text fontWeight="medium" fontSize="sm">3. Make appointment & enter details</Text>
                </ListItem>
                <ListItem>
                  <Text fontWeight="medium" fontSize="sm">4. Copy booking link from email</Text>
                </ListItem>
                <ListItem>
                  <Text fontWeight="medium" fontSize="sm">5. Paste URL in Application URL field</Text>
                  <Text fontSize="xs" bg="gray.100" p={2} borderRadius="md" fontFamily="mono" mt={1}>
                    https://www.ch-edoc-reservation.admin.ch/#/session?token=xxxxx&locale=en-US
                  </Text>
                </ListItem>
              </List>
            ) : (
              // Desktop version - current detailed instructions
              <List spacing={3}>
                <ListItem>
                  <Text fontWeight="medium">1. Sign up on the Swiss visa website</Text>
                  <Text fontSize="sm" color="gray.600">
                    Create an account on the official Swiss visa application website.
                  </Text>
                </ListItem>
                <ListItem>
                  <Text fontWeight="medium">2. Select your Country & Embassy</Text>
                  <Text fontSize="sm" color="gray.600">
                    Choose your country and the responsible embassy/consulate.
                  </Text>
                </ListItem>
                <ListItem>
                  <Text fontWeight="medium">3. Make an appointment</Text>
                  <Text fontSize="sm" color="gray.600">
                    Click "make an appointment" and enter your details.
                  </Text>
                </ListItem>
                <ListItem>
                  <Text fontWeight="medium">4. Copy the booking link from email</Text>
                  <Text fontSize="sm" color="gray.600">
                    Once you receive the booking link in your email, copy it.
                  </Text>
                </ListItem>
                <ListItem>
                  <Text fontWeight="medium">5. Paste the URL in the Application URL field</Text>
                  <Text fontSize="sm" color="gray.600">
                    The URL should look like this:
                  </Text>
                  <Text fontSize="xs" bg="gray.100" p={2} borderRadius="md" fontFamily="mono" mt={1}>
                    https://www.ch-edoc-reservation.admin.ch/#/session?token=xxxxx&locale=en-US
                  </Text>
                </ListItem>
              </List>
            )}
            <Text fontSize={['xs', 'sm']} color="orange.600" fontWeight="medium" mt={2}>
              This URL is required so we can monitor the appointment system for available slots.
            </Text>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="brand" onClick={onClose}>
            Got it
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
} 